module.exports = __webpack_public_path__ + "img/mid_1.ee6b5437.png";